import { merge } from 'lodash'
import camelize from 'camelize'

export default class BaseModel {
  constructor (data) {
    merge(this, data)
  }

  static fromDataPacket (data) {
    const Model = this
    const norm = camelize(data)

    return new Model(norm)
  }
}



// WEBPACK FOOTER //
// ./src/api/BaseModel.js